import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useFormikContext } from 'formik'

import { Box, Checkbox, createFilterOptions } from '@mui/material'
import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material'
import AutocompleteCustom from '@/views/components/autocomplete-custom/index.component'

import { ApplicationState } from '@/state/root.models'
import { FormValuesManualWallet } from '@/views/wallets/hooks/use-wallets-schema.hook'
import { BonusType } from '@/enums/be-bonus-type.enum'

type Props = {
  bonusType: BonusType
}

export const ProviderComponent = ({ bonusType }: Props) => {
  const { t } = useTranslation()

  const { values, setFieldValue, touched, errors, setFieldTouched } =
    useFormikContext<FormValuesManualWallet>()

  const { providers } = useSelector(
    ({ bonusEngine }: ApplicationState) => bonusEngine,
  )

  let listProviders =
    providers !== undefined
      ? providers
          .filter((item: any) => item.name !== undefined)
          .map((provider: any) => {
            return {
              label: provider.name,
              value: provider.externalID,
            }
          })
      : []

  listProviders =
    bonusType === BonusType.BETSOFT_CASINO
      ? listProviders.filter((item) => item.value === 15)
      : listProviders
  // : listProviders.filter(
  //     (item) =>
  //       item.value === 15 ||
  //       item.value === 34 ||
  //       item.value === 36 ||
  //       item.value === 93 ||
  //       item.value === 94 ||
  //       item.value === 95 ||
  //       item.value === 97 ||
  //       item.value === 101 ||
  //       item.value === 102 ||
  //       item.value === 108 ||
  //       item.value === 120 ||
  //       item.value === 126 ||
  //       item.value === 144 ||
  //       item.value === 145 ||
  //       item.value === 150 ||
  //       item.value === 151,
  //   )

  const allSelected = listProviders.length === values.providers.length

  const handleSelectAll = (isSelected: boolean) => {
    if (isSelected) {
      setFieldValue('providers', listProviders)
    } else {
      setFieldValue('providers', [])
    }
  }

  const handleToggleSelectAll = () => {
    handleSelectAll && handleSelectAll(!allSelected)
  }

  const handleChange = (event: any, selectedOptions: any[], reason: string) => {
    if (reason === 'selectOption' || reason === 'removeOption') {
      if (selectedOptions.find((option) => option.value === 'select-all')) {
        handleToggleSelectAll()
      } else if (reason === 'removeOption') {
        setFieldValue('providers', selectedOptions)
      } else {
        const findValue =
          selectedOptions.length > 0 &&
          values.providers.length > 0 &&
          values.providers.find(
            (item: any) =>
              item.label === selectedOptions[selectedOptions.length - 1].label,
          )

        if (findValue) {
          const removeValue = values.providers.filter(
            (provider: any) =>
              provider.label !==
              selectedOptions[selectedOptions.length - 1].label,
          )
          setFieldValue('providers', removeValue)
        } else {
          setFieldValue('providers', selectedOptions)
        }
      }
    } else if (reason === 'clear') {
      setFieldValue('providers', [])
    }
  }

  const filter = createFilterOptions()

  return (
    <Box>
      <AutocompleteCustom
        limitTags={3}
        multiple
        onChange={handleChange}
        chipTags
        freeSolo
        disabled={listProviders.length === 0}
        options={listProviders}
        value={values.providers || []}
        label={t('providers')}
        getOptionLabel={(option) => `${option.label} - ${option.value}`}
        onBlur={() => setFieldTouched('providers', true)}
        error={touched.providers && Boolean(errors.providers)}
        helperText={
          touched.providers && errors.providers
            ? (errors.providers as string)
            : ''
        }
        filterOptions={(options: any, params: any) => {
          const filtered = filter(options, params)
          return [
            { label: t('labels.selectAll'), value: 'select-all' },
            ...filtered,
          ]
        }}
        renderOption={(props, option) => {
          const selectAllProps =
            option.value === 'select-all' // To control the state of 'select-all' checkbox
              ? { checked: allSelected }
              : {}

          return (
            <li {...props}>
              <Checkbox
                color="primary"
                icon={<CheckBoxOutlineBlank fontSize="small" />}
                checkedIcon={<CheckBox fontSize="small" />}
                style={{ marginRight: 8 }}
                checked={
                  values.providers
                    ? values.providers.filter(
                        (provider: any) => provider.label === option.label,
                      ).length > 0
                    : false
                }
                {...selectAllProps}
              />
              {option.value === 'select-all' ? (
                <span className="select-all-items">
                  <em>{option.label}</em>
                </span>
              ) : (
                `${option.label} - ${option.value}`
              )}
            </li>
          )
        }}
      />
    </Box>
  )
}
